import { useCallback } from 'react';
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
import useLocaleNavigate from 'utils/customHooks/useLocaleNavigate';
import { goUp } from 'helpers';

const useCheckoutNavigation = () => {
  const navigate = useLocaleNavigate();
  const { assignedLibrary } = useAssignedLibrary();

  const goToStep = useCallback(
    (step) => {
      if (step === 0) {
        navigate(`/${assignedLibrary}/carrito`);
      } else if (step === 1) {
        navigate(`/${assignedLibrary}/envio`);
      } else if (step === 2) {
        navigate(`/${assignedLibrary}/pago`, { state: { checkoutPhase: 'billing' } });
      } else if (step === 3) {
        navigate(`/${assignedLibrary}/pago`, { state: { checkoutPhase: 'payment' } });
      }
      goUp();
    },
    [assignedLibrary, navigate]
  );

  return { goToStep };
};

export default useCheckoutNavigation;
